import { getPlans } from '@smarty-nx/contentful'
import { logErrorAndNotify } from '@smarty-nx/debug-utils'

import { colors } from '../../index'

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const planStyles: any[] = getPlans()

/**
 * Plan styling utility function
 * Pass in the plan ID (SM_8GB) and it'll return the styles in an object:
 * styles.planColor, styles.planColorPale, styles.color (text color), styles.chipColor
 * */
const getPlanStyles = (planId: string | undefined) => {
  if (planId === 'Loading') {
    return {
      planColor: colors['UI/LightGrey'],
      color: colors['Brand/PrimaryBlack'],
    }
  }
  const plan = planStyles.find((plan) => plan.id === planId)
  if (!plan) {
    logErrorAndNotify(`PLAN ${planId} IS MISSING STYLING!`)
    // TODO - Agree some sensible default values for when plans are missing styles out of the CMS https://smarty-mobile.atlassian.net/browse/DIGDEV-11550
    return {
      planColor: 'hotpink',
      planColorPale: 'hotpink',
      color: 'black',
      chipColor: 'hotpink',
    }
  }
  return {
    planColor: plan.planColor.colourCode,
    planColorPale: plan.planColorPale.colourCode,
    color: colors['Brand/PrimaryBlack'],
  }
}

export { getPlanStyles }
